import React from 'react';

/**
 * Footer réutilisable pour Fortuneo Immobilier.
 * - Affiche logo + nom société + infos légales
 * - Optionnel : lien "Contact" (uniquement pour l'espace client connecté)
 *
 * Props :
 *   showContact  : boolean  -> affiche le lien Contact
 *   onContactClick : func   -> callback exécuté au clic sur "Contact"
 */
const Footer = ({ showContact = false, onContactClick, accentColor = '#82C43C' }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="w-full border-t bg-white"
      style={{ borderColor: '#E5E7EB' }}
      data-testid="app-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
          {/* Logo + nom société */}
          <div className="flex flex-col items-start">
            <img
              src="https://customer-assets.emergentagent.com/job_fd99e742-6c59-4267-85f6-7d5b0b735f5d/artifacts/83jkoc66_IMG_0229.jpeg"
              alt="Fortuneo Banque"
              className="h-10 md:h-12 object-contain mb-3"
            />
            <p className="text-sm font-semibold" style={{ color: '#333333' }}>
              Fortuneo Banque
            </p>
            <p className="text-xs mt-1" style={{ color: '#6B7280' }}>
              Filiale du Crédit Mutuel Arkéa
            </p>
          </div>

          {/* Informations société */}
          <div className="flex-1 md:px-8">
            <h3
              className="text-sm font-semibold mb-2"
              style={{ color: accentColor }}
            >
              Informations société
            </h3>
            <ul className="space-y-1 text-xs" style={{ color: '#4B5563' }}>
              <li>Siège social : Immeuble Ar Kreiz — Rue Blaise Pascal, 29200 Brest</li>
              <li>SA au capital de 27 260 500 €</li>
              <li>SIREN 362 942 097 — RCS Brest</li>
              <li>N° ORIAS : 07 008 441 (www.orias.fr)</li>
              <li>Contrôlée par l&apos;ACPR — 4 Place de Budapest, 75009 Paris</li>
            </ul>
          </div>

          {/* Lien Contact (uniquement espace client) */}
          {showContact && (
            <div className="flex flex-col items-start md:items-end">
              <h3
                className="text-sm font-semibold mb-2"
                style={{ color: accentColor }}
              >
                Besoin d&apos;aide ?
              </h3>
              <button
                type="button"
                onClick={onContactClick}
                className="text-sm font-medium underline-offset-4 hover:underline transition-colors"
                style={{ color: accentColor }}
                data-testid="footer-contact-link"
              >
                Contacter mon conseiller
              </button>
            </div>
          )}
        </div>

        {/* Barre du bas */}
        <div
          className="mt-6 pt-4 border-t text-center text-xs"
          style={{ borderColor: '#E5E7EB', color: '#9CA3AF' }}
        >
          © {currentYear} Fortuneo Banque. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
